<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="pt2"> </p>
<p class="PT">ARRIVAL</p>
<p class="PEP">We may prefer to think of ourselves as fallen angels, but in reality we are rising apes.</p>
<div class="PEPC-SP">
<p class="PEPC"><span class="pepc-CAPS">D</span><span class="ePub-SC">ESMOND</span> <span class="pepc-CAPS">M</span><span class="ePub-SC">ORRIS</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part2.vue?058ad024